import styled from 'styled-components';

export const StyledImageExpander = styled.div`
  img {
    &:hover {
      cursor: pointer;
    }
  }
`;
